import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import InstagramOutlinedSvg from "@ant-design/icons-svg/es/asn/InstagramOutlined";
import AntdIcon from "../components/AntdIcon";
var InstagramOutlined = function InstagramOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: InstagramOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  InstagramOutlined.displayName = 'InstagramOutlined';
}
export default /*#__PURE__*/React.forwardRef(InstagramOutlined);